// extracted by mini-css-extract-plugin
export default {"favorite_recipes":"FavoriteRecipes_favorite_recipes__ntTaa","cards":"FavoriteRecipes_cards__itIrM"};